module.exports = __webpack_public_path__ + "images/liinilaevad/ms-icon-144x144.png";